import { useState } from 'react';
import { useRecoilState } from 'recoil';
import roomDetailState, { PickType } from '../../../atoms/roomDetail';
import emitPick from '../../../connector/emits/pick';
import './Pick.scoped.scss';

const Pick = () => {
  const [roomDetail] = useRecoilState(roomDetailState);

  const [powerballOddEvenPick, setPowerballOddEvenPick] = useState('');
  const [powerballUnderOverPick, setPowerballUnderOverPick] = useState('');
  const [sumOddEvenPick, setSumOddEvenPick] = useState('');
  const [sumUnderOverPick, setSumUnderOverPick] = useState('');
  const [sumHighLowPick, setSumHighLowPick] = useState('');

  const submitPick = () => {
    if (
      roomDetail.pickHistory[0].pick !== PickType.NONE &&
      roomDetail.pickHistory[0].pick !== PickType.PAST
    ) {
      window.alert('이미 이번 회차 픽을 선택 하셨습니다.');
      return;
    }

    const remainSecond = Math.ceil((300000 - ((new Date()).getTime() + 25000) % 300000) / 1000);
    if (remainSecond > 298 || remainSecond <= 50) {
      window.alert('결과 발표 50초 이전부터는 픽을 선택할 수 없습니다.');
      return;
    }

    if (
      powerballOddEvenPick === ''
      && powerballUnderOverPick === ''
      && sumOddEvenPick === ''
      && sumUnderOverPick === ''
      && sumHighLowPick === ''
    ) {
      window.alert('픽을 선택해주세요.');
      return;
    }

    emitPick(
      `${powerballOddEvenPick}|${powerballUnderOverPick}`
      + `|${sumOddEvenPick}|${sumUnderOverPick}|${sumHighLowPick}`
    );
  };

  const resetPick = () => {
    setPowerballOddEvenPick('');
    setPowerballUnderOverPick('');
    setSumOddEvenPick('');
    setSumUnderOverPick('');
    setSumHighLowPick('');
  };

  return (
    <div className="pick">
      <div className="pick__left">
        <div className="pick__row">
          <div className="pick__row__title">파워볼</div>
          <button
            className="pick__pick-button"
            style={{
              marginLeft: '6px',
              background: powerballOddEvenPick === '홀' ? '#1265cd' : 'white',
              borderColor: powerballOddEvenPick === '홀' ? '#180b85' : '#cccccc',
              color: powerballOddEvenPick === '홀' ? 'white' : '#303030'
            }}
            onClick={() => setPowerballOddEvenPick('홀')}
          >
            홀
          </button>
          <button
            className="pick__pick-button"
            style={{
              background: powerballOddEvenPick === '짝' ? '#cd1212' : 'white',
              borderColor: powerballOddEvenPick === '짝' ? '#850b0b' : '#cccccc',
              color: powerballOddEvenPick === '짝' ? 'white' : '#303030'
            }}
            onClick={() => setPowerballOddEvenPick('짝')}
          >
            짝
          </button>
          <button
            className="pick__pick-button"
            style={{
              marginLeft: '6px',
              background: powerballUnderOverPick === '언더' ? '#1265cd' : 'white',
              borderColor: powerballUnderOverPick === '언더' ? '#180b85' : '#cccccc',
              color: powerballUnderOverPick === '언더' ? 'white' : '#303030'
            }}
            onClick={() => setPowerballUnderOverPick('언더')}
          >
            언더
          </button>
          <button
            className="pick__pick-button"
            style={{
              background: powerballUnderOverPick === '오버' ? '#cd1212' : 'white',
              borderColor: powerballUnderOverPick === '오버' ? '#850b0b' : '#cccccc',
              color: powerballUnderOverPick === '오버' ? 'white' : '#303030'
            }}
            onClick={() => setPowerballUnderOverPick('오버')}
          >
            오버
          </button>
        </div>
        <div className="pick__row">
          <div className="pick__row__title">숫자합</div>
          <button
            className="pick__pick-button"
            style={{
              marginLeft: '6px',
              background: sumOddEvenPick === '홀' ? '#1265cd' : 'white',
              borderColor: sumOddEvenPick === '홀' ? '#180b85' : '#cccccc',
              color: sumOddEvenPick === '홀' ? 'white' : '#303030'
            }}
            onClick={() => setSumOddEvenPick('홀')}
          >
            홀
          </button>
          <button
            className="pick__pick-button"
            style={{
              background: sumOddEvenPick === '짝' ? '#cd1212' : 'white',
              borderColor: sumOddEvenPick === '짝' ? '#850b0b' : '#cccccc',
              color: sumOddEvenPick === '짝' ? 'white' : '#303030'
            }}
            onClick={() => setSumOddEvenPick('짝')}
          >
            짝
          </button>
          <button
            className="pick__pick-button"
            style={{
              marginLeft: '6px',
              background: sumUnderOverPick === '언더' ? '#1265cd' : 'white',
              borderColor: sumUnderOverPick === '언더' ? '#180b85' : '#cccccc',
              color: sumUnderOverPick === '언더' ? 'white' : '#303030'
            }}
            onClick={() => setSumUnderOverPick('언더')}
          >
            언더
          </button>
          <button
            className="pick__pick-button"
            style={{
              background: sumUnderOverPick === '오버' ? '#cd1212' : 'white',
              borderColor: sumUnderOverPick === '오버' ? '#850b0b' : '#cccccc',
              color: sumUnderOverPick === '오버' ? 'white' : '#303030'
            }}
            onClick={() => setSumUnderOverPick('오버')}
          >
            오버
          </button>
          <button
            className="pick__pick-button"
            style={{
              marginLeft: '6px',
              background: sumHighLowPick === '대' ? '#cd1212' : 'white',
              borderColor: sumHighLowPick === '대' ? '#850b0b' : '#cccccc',
              color: sumHighLowPick === '대' ? 'white' : '#303030'
            }}
            onClick={() => setSumHighLowPick('대')}
          >
            대
          </button>
          <button
            className="pick__pick-button"
            style={{
              background: sumHighLowPick === '중' ? '#14805E' : 'white',
              borderColor: sumHighLowPick === '중' ? '#064c1c' : '#cccccc',
              color: sumHighLowPick === '중' ? 'white' : '#303030'
            }}
            onClick={() => setSumHighLowPick('중')}
          >
            중
          </button>
          <button
            className="pick__pick-button"
            style={{

              background: sumHighLowPick === '소' ? '#1265cd' : 'white',
              borderColor: sumHighLowPick === '소' ? '#180b85' : '#cccccc',
              color: sumHighLowPick === '소' ? 'white' : '#303030'
            }}
            onClick={() => setSumHighLowPick('소')}
          >
            소
          </button>
        </div>
      </div>
      <div className="pick__right">
        <button onClick={submitPick}>픽하기</button>
        <button onClick={resetPick}>리셋</button>
      </div>
    </div>
  );
};

export default Pick;
